module.exports = __webpack_public_path__ + "icons/icon-question.7633da06.svg";